import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=1309d150&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../wxpush/sources/client/wxpush-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1309d150",
  null
  
)

export default component.exports